/**
 * Status of a call session
 */
export enum CallStatusEnum {
  ACTIVE = "active",
  COMPLETED = "completed",
  FAILED = "failed",
  TERMINATED = "terminated"
}
